import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["aria-expanded", "aria-current"]
const _hoisted_3 = { class: "jtv-key-content" }
const _hoisted_4 = { class: "jtv-key-label" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "jtv-highlight"
}
const _hoisted_7 = { class: "properties" }
const _hoisted_8 = ["id", "role", "tabindex", "aria-current"]
const _hoisted_9 = { class: "value-row" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "jtv-highlight"
}
const _hoisted_12 = {
  ref: "valueTextRef",
  class: "value-text",
  contenteditable: "false"
}
const _hoisted_13 = {
  key: 0,
  class: "jtv-highlight"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "jtv-highlight"
}
const _hoisted_16 = {
  ref: "valueTextRef",
  class: "value-text",
  contenteditable: "false"
}
const _hoisted_17 = {
  key: 0,
  class: "jtv-highlight"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JsonTreeViewItem = _resolveComponent("JsonTreeViewItem", true)!
  const _component_ElTooltip = _resolveComponent("ElTooltip")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['json-view-item', 'depth-' + _ctx.data.depth])
  }, [
    (_ctx.data.type === _ctx.ItemType.OBJECT || _ctx.data.type === _ctx.ItemType.ARRAY)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            class: _normalizeClass(['data-key', _ctx.isActiveMatch ? 'jtv-node--active' : '']),
            "aria-expanded": _ctx.isOpen ? 'true' : 'false',
            "aria-current": _ctx.isActiveMatch ? 'true' : undefined,
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.toggleOpen(_ctx.data)), ["stop"]))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.classes)
            }, null, 2),
            _createElementVNode("span", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keySegmentsFor(_ctx.containerKeyText), (seg, i) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                    (seg.breakBefore)
                      ? (_openBlock(), _createElementBlock("wbr", _hoisted_5))
                      : _createCommentVNode("", true),
                    (seg.hit)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(seg.text), 1))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(seg.text), 1)
                        ], 64))
                  ], 64))
                }), 128))
              ]),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.lengthString), 1)
            ])
          ], 10, _hoisted_2),
          (_ctx.isOpen)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "children-branch",
                style: _normalizeStyle(_ctx.branchIndentStyle)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.children, (child) => {
                  return (_openBlock(), _createBlock(_component_JsonTreeViewItem, {
                    key: _ctx.getKey(child),
                    data: child,
                    maxDepth: _ctx.maxDepth,
                    canSelect: _ctx.canSelect,
                    objectMap: _ctx.objectMap,
                    tab: _ctx.tab,
                    path: _ctx.path,
                    element: _ctx.element,
                    onSelected: _ctx.bubbleSelected,
                    "click-able-data-type": _ctx.clickAbleDataType,
                    "search-query": _ctx.searchQuery,
                    "active-search-path": _ctx.activeSearchPath,
                    "has-active-search-match": _ctx.hasActiveSearchMatch,
                    "expanded-paths": _ctx.expandedPaths
                  }, null, 8, ["data", "maxDepth", "canSelect", "objectMap", "tab", "path", "element", "onSelected", "click-able-data-type", "search-query", "active-search-path", "has-active-search-match", "expanded-paths"]))
                }), 128))
              ], 4))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.type === _ctx.ItemType.VALUE)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          id: 'item-'+ _ctx.data.path + '-' + _ctx.tab,
          class: _normalizeClass([_ctx.valueClasses, _ctx.matchedElements(_ctx.data) ? 'match':'', _ctx.isActiveMatch ? 'jtv-node--active' : '']),
          role: _ctx.canSelect ? 'button' : undefined,
          tabindex: _ctx.canSelect ? '0' : undefined,
          "aria-current": _ctx.isActiveMatch ? 'true' : undefined,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onClick(_ctx.data))),
          onKeyup: [
            _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.onClick(_ctx.data)), ["enter"])),
            _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.onClick(_ctx.data)), ["space"]))
          ],
          style: _normalizeStyle({ backgroundColor : _ctx.getKeyColor(_ctx.data.path)})
        }, [
          _createElementVNode("div", _hoisted_9, [
            (_ctx.showTooltip)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_ElTooltip, {
                    effect: "custom",
                    content: _ctx.data.value,
                    placement: "left",
                    "popper-class": "jtv-tooltip"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", {
                        class: _normalizeClass(['scrollable-tooltip-content', { 'overflow-auto': _ctx.isOverflowing }])
                      }, _toDisplayString(_ctx.data.value), 3)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        class: _normalizeClass([_ctx.setClass(_ctx.tab), { 'jtv-empty-key': _ctx.isEmptyKey }]),
                        contenteditable: "false"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keySegmentsFor(_ctx.keyForDisplay(_ctx.data.key)), (seg, i) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                            (seg.breakBefore)
                              ? (_openBlock(), _createElementBlock("wbr", _hoisted_10))
                              : _createCommentVNode("", true),
                            (seg.hit)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(seg.text), 1))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createTextVNode(_toDisplayString(seg.text), 1)
                                ], 64))
                          ], 64))
                        }), 128))
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["content"]),
                  _createElementVNode("span", _hoisted_12, [
                    (_ctx.isSearching)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.segmentsFor(_ctx.valueTextForDisplay), (seg, i) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                            (seg.hit)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(seg.text), 1))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(seg.text), 1)
                                ], 64))
                          ], 64))
                        }), 128))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.data.value), 1)
                        ], 64))
                  ], 512)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("span", {
                    class: _normalizeClass([_ctx.setClass(_ctx.tab), { 'jtv-empty-key': _ctx.isEmptyKey }]),
                    contenteditable: "false"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keySegmentsFor(_ctx.keyForDisplay(_ctx.data.key)), (seg, i) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                        (seg.breakBefore)
                          ? (_openBlock(), _createElementBlock("wbr", _hoisted_14))
                          : _createCommentVNode("", true),
                        (seg.hit)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(seg.text), 1))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode(_toDisplayString(seg.text), 1)
                            ], 64))
                      ], 64))
                    }), 128))
                  ], 2),
                  _createElementVNode("span", _hoisted_16, [
                    (_ctx.isSearching)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.segmentsFor(_ctx.valueTextForDisplay), (seg, i) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                            (seg.hit)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(seg.text), 1))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(seg.text), 1)
                                ], 64))
                          ], 64))
                        }), 128))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(_ctx.data.value), 1)
                        ], 64))
                  ], 512)
                ], 64)),
            _createVNode(_component_ElTooltip, {
              effect: "custom",
              content: _ctx.t('Common.CopyValue'),
              placement: "bottom",
              "popper-class": "jtv-tooltip"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, {
                  class: "copy-btn",
                  icon: _ctx.copied ? 'check' : 'clone',
                  role: "button",
                  tabindex: "0",
                  "aria-label": _ctx.copied ? 'Copied' : 'Copy value',
                  title: "Copy",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.copyValue()), ["stop"])),
                  onKeyup: [
                    _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (_ctx.copyValue()), ["stop"]), ["enter"])),
                    _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.copyValue()), ["stop"]), ["space"]))
                  ]
                }, null, 8, ["icon", "aria-label"])
              ]),
              _: 1
            }, 8, ["content"])
          ])
        ], 46, _hoisted_8))
      : _createCommentVNode("", true)
  ], 2))
}